/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-vars */
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNameTypeDataServerProps } from 'src/actions/nameTypeActions';
import { searchForAllCountriesStaticProps } from 'src/actions/searchActions';
import { NavFooter } from 'src/components/nav/navFooter.component';
import type {
  LastNameDataObject,
  LastNameReducerState,
} from 'src/reducers/lastNameReducer';
import { lastNameActions } from 'src/reducers/lastNameReducer';
import type { RootState } from 'src/store';
import type { OptionTypes } from 'src/types/actionSheetTypes';
import { getCountryStaticProps } from '../../actions/countryActions';
import StandardSEOWrapper from '../../components/layout/standardSEOWrapper.component';
import PersonPage from '../../components/person/person-page';
import { worldDomainName } from '../../config';
import { choose } from '../../utils/arrays';
import { capitalizeString } from '../../utils/string';

export default function FirstNamePage({
  countries,
  lastNameDataProps,
  hasFirstNameData,
  firstNameSuggestions,
}: any) {
  const dispatch = useDispatch();

  const router = useRouter();
  const lastname = ((router.query.lastname_slug
    ?.toString()
    .charAt(0)
    .toUpperCase() as string) +
    router.query.lastname_slug?.toString().slice(1)) as string;

  const {
    lastNameData,
  }: // lastNameAges,
  // lastNamesSoundingLike,
  Pick<
    LastNameReducerState,
    'lastNameData' | 'lastNameAges' | 'lastNamesSoundingLike'
  > = useSelector(
    ({
      lastName: { lastNameData, lastNameAges, lastNamesSoundingLike },
    }: RootState) => ({
      lastNameData,
      lastNameAges,
      lastNamesSoundingLike,
    })
  );

  const copyOfLastNameData = lastNameData ? [...lastNameData] : [];

  const sortedFirstNameData = copyOfLastNameData?.sort(
    (a: { count: number }, b: { count: number }) => {
      return b.count - a.count;
    }
  );

  const completeArrayOfLastNameData: LastNameDataObject[][] = [];

  sortedFirstNameData?.forEach(
    (x: LastNameDataObject, y: number, z: LastNameDataObject[]) => {
      return !(y % 10)
        ? completeArrayOfLastNameData?.push(z.slice(y, y + 10))
        : '';
    }
  );

  let numberOfHumansFound = 0;

  lastNameData.forEach((data) => {
    numberOfHumansFound = numberOfHumansFound + data.count;
  });

  useEffect(() => {
    if (!isEmpty(lastNameDataProps)) {
      const result = lastNameDataProps.countries;
      dispatch(lastNameActions.setLastNameData({ lastNameData: result }));
    }
  }, []);

  const [menuOption, setMenuOption] = useState<OptionTypes>('');

  const handleOption = (option: OptionTypes) => () => {
    setMenuOption(option);
  };

  const { t } = useTranslation('last-name-slug');

  return (
    <div
      className={`relative flex min-h-dvh min-w-full flex-col overflow-x-hidden bg-[#FAFAFA] max-md:pb-[120px] md:pt-[100px]`}
    >
      <StandardSEOWrapper
        title={t('last-name-slug:seo.title', { lastName: lastname })}
        description={t('last-name-slug:seo.description', {
          lastName: lastname,
        })}
      />
      <PersonPage
        countries={countries}
        personNameDataProps={lastNameDataProps}
        nameType="last"
        personNameData={lastNameData}
        hasDataForOppositeNameType={hasFirstNameData}
        nameSuggestions={firstNameSuggestions}
      />

      <NavFooter className="mt-auto" />
    </div>
  );
}

export const getStaticProps = async ({
  locale,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  params: { lastname_slug },
}: {
  locale: string;
  params: { lastname_slug: string };
}) => {
  let countries, WORData, lastNameData, firstNameData, translations;

  try {
    [countries, WORData, lastNameData, firstNameData, translations] =
      await Promise.all([
        searchForAllCountriesStaticProps(),
        getCountryStaticProps('WOR', worldDomainName),
        getNameTypeDataServerProps('last', lastname_slug),
        getNameTypeDataServerProps('first', lastname_slug),
        serverSideTranslations(locale ?? 'en', [
          'common',
          'navbar',
          'new-homepage',
          'new-navbar',
          'new-footer',
          'last-name-slug',
          'person',
        ]),
      ]);
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      ...(translations ?? {}),
      countries: countries ?? [],
      lastNameDataProps: lastNameData ?? {},
      hasFirstNameData: !!firstNameData,
      firstNameSuggestions: Array.isArray((WORData ?? {})?.top_first_names)
        ? (
            choose(((WORData ?? {})?.top_first_names ?? []).slice(30), 8) ?? []
          ).map((x: any) => capitalizeString(x.name))
        : [],
    },
    revalidate: 60 * 60 * 24,
  };
};

export const getStaticPaths = async () => {
  // We'll pre-render only these paths at build time.
  // { fallback: blocking } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths: [], fallback: 'blocking' };
};
